import script from "./ArticleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&setup=true&lang=js"

import "./ArticleEdit.vue?vue&type=style&index=0&id=6294249a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6294249a"]])

export default __exports__